// Libraries
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Import component
import Button from "../button/button";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";

// Import supabase configuration
import supabase from "../../config/supabase";
import { FormControl } from "@mui/material";


const useStyles = makeStyles((theme) => ({
  quantityRoot: {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
      // borderRadius: "5px",
      outline: "none"
    },
  }
}))

// Component
function Header({ current = "none", clientView = false, show = false }) {
  const navigate = useNavigate();
  const [currentValue, setCurrent] = useState(current);
  const [show_dropdown, setShow] = useState(show);

  const classes = useStyles();

  // Function to toggle dropdown
  const toggle = () => {
    // Set state
    setCurrent(!show_dropdown);
  };

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      "&:focus": {
        borderRadius: 4,
        borderColor: "",
        boxShadow: "",
      },
    },
  }));

  const handleLogout = async (event) => {
    // Log out
    if (event.target.value === "Log Out") {
      const { error } = await supabase.auth.signOut();
      if (!error) {
        localStorage.clear();
        navigate("/login");
      }
    }
    // // ATS board
    if (event.target.value === "Board") {
      navigate("/board");
    }
    // // Add New Candidate
    if (event.target.value === "Add candidate") {
      navigate("/addCandidates");
    }
  };

  // return
  return (
    // Render header
    <div className="flex sticky top-0 z-20">
      <div className="flex justify-between items-center relative w-full h-20 bg-white-1 px-10 box-border">
        {/* Make a group */}
        <div className="flex relative">
          {/* Add icon */}
          <a href="/">
            <img src="/Gaperio2.svg" className="h-full w-auto ml-5" />
          </a>
        </div>
        
        {/* Add logout option */}
        <div className="sm:flex hidden justify-center ml-8">
          {/* Content */}
          <Avatar alt="Profile" src="./avatar.png" className="mt-1"/>
  
          <FormControl variant="outlined" classes={{
                root: classes.quantityRoot
              }}>
            <Select
              sx={{ marginLeft: "10px" }}
              labelId="header"
              id="header"
              value=""
              onChange={handleLogout}
            >
              <MenuItem value="Board">
                <em>Board</em>
              </MenuItem>
              <MenuItem value="Add candidate">
                <em>Add candidate</em>
              </MenuItem>
              <MenuItem value="Log Out">
                <em>Log Out</em>
              </MenuItem>
            </Select>
          </FormControl>
        </div>
  
        {/* Add the menu dropdown */}
        <div className="sm:hidden ml-8 w-12">
          {/* Div to hold button */}
          <div className="flex flex-col justify-center h-full">
            {/* Button */}
            <Button onClick={() => toggle()}>
              {/* Add svg */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="#fff"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z" />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Export the Component
export default Header;
